import React, { useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";

import phoneIcon from "../../../assets/package/location.png";

import "./LocationListItem.css";

const createCurrencyFormatter = (currency) =>
  new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const LocationListItem = ({
                            id,
                            name,
                            minPricePerGb,
                            type = "country",
                            selected = false,
                            onClick,
                            isFirst = false,
                            isLast = false,
                            isCurrentLocation = false,
                            "data-country-id": dataCountryId,
                          }) => {
  const { walletCurrency } = useContext(AuthContext);
  const isRegion = type === "region";

  const formatter = createCurrencyFormatter(walletCurrency || "EUR");
  const priceFormatted = formatter.format(minPricePerGb);

  const folder = isRegion ? "regions" : "flags";
  const iconCode = id ? String(id).toLowerCase() : "";
  const iconSrc = iconCode ? `/icons/${folder}/${iconCode}.png` : null;

  const itemClassNames = [
    "location-item",
    selected ? "location-item--selected" : "",
    isFirst ? "location-item--first" : "",
    isLast ? "location-item--last" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={itemClassNames} onClick={onClick} data-country-id={dataCountryId || id}>
      <div className="location-item-left">
        {iconSrc && (
          <img
            src={iconSrc}
            alt={name}
            className={"location-item-flag" + (isRegion ? " location-item-region-icon" : "")}
          />
        )}
        <span className="location-item-name">{name}</span>
        {isCurrentLocation && <img src={phoneIcon} className="location-item-current-icon" />}
      </div>

      <div className="location-item-right">
        <span className="location-item-label">from</span>
        <span className="location-item-price">{priceFormatted}/GB</span>
      </div>
    </div>
  );
};

export default LocationListItem;
